// extracted by mini-css-extract-plugin
module.exports = {"reportsMiddle-border":"CreateReport_reportsMiddle-border__1L3FU"};